/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Calendar_Sync_Subtitle_P1Inputs */

const en_candidate_profile_calendar_sync_subtitle_p1 = /** @type {(inputs: Candidate_Profile_Calendar_Sync_Subtitle_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add all appointments as a link to your calendar and automatically synchronize all updates.`)
};

const de_candidate_profile_calendar_sync_subtitle_p1 = /** @type {(inputs: Candidate_Profile_Calendar_Sync_Subtitle_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Termine als Link in Ihren Kalender eintragen und alle Updates automatisch synchronisieren.`)
};

/**
* | output |
* | --- |
* | "Add all appointments as a link to your calendar and automatically synchronize all updates." |
*
* @param {Candidate_Profile_Calendar_Sync_Subtitle_P1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_calendar_sync_subtitle_p1 = /** @type {((inputs?: Candidate_Profile_Calendar_Sync_Subtitle_P1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Calendar_Sync_Subtitle_P1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_calendar_sync_subtitle_p1(inputs)
	return en_candidate_profile_calendar_sync_subtitle_p1(inputs)
});